/* MoRetro Studio V27 - Workshop machine store. Library is the source of truth. */
window.MTS = window.MTS || {};

(function(MTS){
  "use strict";

  const cfg = MTS.WorkshopConfig;
  const st = cfg.state;
  const h = cfg.h;

  function settingsPrintersRaw(){
    const list = MTS.state?.settings?.printers;
    return Array.isArray(list) ? list : null;
  }

  function settingsControlsPrinters(){
    return Array.isArray(MTS.state?.settings?.printers);
  }

  function basePrinters(){
    const settingsPrinters = settingsPrintersRaw();
    if(Array.isArray(settingsPrinters)){
      return settingsPrinters.filter(p=>p.active !== false).map(h.defaultMachine);
    }

    if(MTS.Settings && typeof MTS.Settings.activePrinters === "function"){
      const list = MTS.Settings.activePrinters();
      if(Array.isArray(list) && list.length) return list.map(h.defaultMachine);
    }

    return cfg.DEFAULT_PRINTERS.map(h.defaultMachine);
  }

  function loadLocal(){
    const keys = [cfg.LOCAL_KEY, ...(cfg.LEGACY_LOCAL_KEYS || [])];
    for(const key of keys){
      try{
        const raw = localStorage.getItem(key);
        if(raw) return JSON.parse(raw);
      }catch(e){}
    }
    return [];
  }

  function saveLocal(list){
    try{ localStorage.setItem(cfg.LOCAL_KEY, JSON.stringify(list || [])); }
    catch(e){ console.warn("Sauvegarde locale machines impossible :", e.message); }
  }

  function comparableMachineName(value){
    return String(value || "")
      .toLowerCase()
      .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      .replace(/bambu\s*lab|bambu/g, "")
      .replace(/[^a-z0-9]/g, "");
  }

  function machineMatchKey(map, machine){
    const m = h.defaultMachine(machine || {});
    if(m.id && map.has(m.id)) return m.id;

    const wantedHost = String(m.host || m.localIp || m.ip || "").trim().toLowerCase();
    const wantedName = String(m.name || "").trim().toLowerCase();
    const wantedComparableName = comparableMachineName(m.name);

    for(const [key, current] of map.entries()){
      const currentHost = String(current.host || current.localIp || current.ip || "").trim().toLowerCase();
      const currentName = String(current.name || "").trim().toLowerCase();
      if(wantedHost && currentHost && wantedHost === currentHost) return key;
      if(wantedName && currentName && wantedName === currentName) return key;
      if(wantedComparableName && wantedComparableName === comparableMachineName(current.name)) return key;
    }
    return "";
  }

  function mergeMachines(base = [], saved = []){
    const settingsMode = settingsControlsPrinters();
    const baseList = (base || []).map(h.defaultMachine);
    const baseIds = new Set(baseList.map(m=>m.id));
    const map = new Map();

    baseList.forEach(m=>map.set(m.id, m));

    (saved || []).forEach(raw=>{
      const incoming = h.defaultMachine(raw);
      const matchKey = machineMatchKey(map, incoming);
      if(settingsMode && !matchKey && !baseIds.has(incoming.id)) return;

      const key = matchKey || incoming.id;
      const current = map.get(key) || {};
      const lockedLibraryFields = settingsMode && current.id ? {
        name: current.name,
        brand: current.brand,
        model: current.model,
        active: current.active,
        materialSystem: current.materialSystem
      } : {};

      map.set(key, h.defaultMachine({...current, ...incoming, ...lockedLibraryFields, id:key}));
    });

    return [...map.values()].filter(m=>{
      if(m.active === false) return false;
      if(settingsMode) return baseIds.has(m.id);
      return true;
    });
  }

  function reconcileMachines(list = st.machines){
    const merged = mergeMachines(basePrinters(), list || []);
    st.machines = merged;
    saveLocal(merged);
    return merged;
  }

  function collection(){
    return MTS.state?.db ? MTS.state.db.collection("machines") : null;
  }

  function scheduleRender(){
    clearTimeout(st.renderTimer);
    st.renderTimer = setTimeout(()=>MTS.Workshop?.render?.(), 80);
  }

  function listenMachines(){
    const col = collection();
    if(!col || st.unsubMachines) return;

    st.unsubMachines = col.onSnapshot(snap=>{
      const remote = [];
      snap.forEach(doc=>remote.push(h.defaultMachine({id:doc.id, ...doc.data()})));
      st.machines = mergeMachines(
        mergeMachines(mergeMachines(basePrinters(), loadLocal()), st.machines),
        remote
      );
      reconcileMachines(st.machines);
      st.loaded = true;
      scheduleRender();
    }, err=>{
      console.warn("Ecoute machines Firestore refusee, utilisation locale :", err.message);
    });
  }

  async function loadMachines(){
    if(st.loading) return st.machines;
    st.loading = true;

    const base = basePrinters();
    st.machines = mergeMachines(base, loadLocal());
    reconcileMachines(st.machines);

    const col = collection();
    if(!col){
      st.loaded = true;
      st.loading = false;
      MTS.WorkshopConnector?.startPolling?.();
      return st.machines;
    }

    try{
      const snap = await col.get();
      const remote = [];
      snap.forEach(doc=>remote.push(h.defaultMachine({id:doc.id, ...doc.data()})));

      if(!remote.length && st.machines.length){
        await Promise.all(st.machines.map(m=>col.doc(m.id).set({
          ...m,
          createdAt: m.createdAt || h.nowIso(),
          updatedAt: firebase.firestore.FieldValue.serverTimestamp()
        }, {merge:true})));
      }else{
        st.machines = mergeMachines(mergeMachines(base, st.machines), remote);
      }

      reconcileMachines(st.machines);
    }catch(err){
      console.warn("Lecture machines Firestore refusee, utilisation locale :", err.message);
    }

    st.loaded = true;
    st.loading = false;
    listenMachines();
    MTS.WorkshopConnector?.startPolling?.();
    return st.machines;
  }

  async function saveMachine(machineId, patch = {}){
    const id = h.uidSafe(machineId);
    const current = st.machines.find(m=>m.id === id) || h.defaultMachine({id});
    const next = h.defaultMachine({...current, ...patch, id, updatedAt:h.nowIso()});

    st.machines = mergeMachines(st.machines, [next]);
    reconcileMachines(st.machines);

    const col = collection();
    if(col){
      try{
        await col.doc(id).set({
          ...next,
          updatedAt: firebase.firestore.FieldValue.serverTimestamp()
        }, {merge:true});
      }catch(err){
        console.warn("Machine sauvegardee en local uniquement :", err.message);
      }
    }

    st.machineDrafts.delete(id);
    MTS.Workshop?.render?.();
    return next;
  }

  function normalizeConnectorMachine(machine = {}){
    const telemetry = h.defaultMachine({
      id: machine.id || machine.machineId || machine.name,
      name: machine.name,
      type: machine.type || machine.connectionType,
      connectionType: machine.type || machine.connectionType,
      host: machine.host || machine.ip || machine.localIp,
      ip: machine.host || machine.ip || machine.localIp,
      localIp: machine.host || machine.ip || machine.localIp,
      port: machine.port,
      online: machine.online,
      state: machine.state || (machine.online ? "ready" : "offline"),
      message: machine.message || machine.error || "",
      progress: machine.progress,
      filename: machine.filename,
      printDuration: machine.printDuration,
      totalDuration: machine.totalDuration,
      nozzleTemp: machine.nozzleTemp ?? machine.extruderTemp,
      nozzleTarget: machine.nozzleTarget ?? machine.extruderTarget,
      bedTemp: machine.bedTemp,
      bedTarget: machine.bedTarget,
      firmware: machine.software || machine.firmware,
      error: machine.error,
      moonraker: machine.moonraker,
      cameraRelay: !!machine.cameraRelay,
      cameraRelayUrl: machine.cameraRelayUrl || "",
      cameraStillUrl: machine.cameraStillUrl || "",
      cameraUpdatedAt: machine.cameraUpdatedAt || "",
      localCameraUrl: machine.localCameraUrl || "",
      lastSeenAt: machine.updatedAt || machine.capturedAt || h.nowIso(),
      updatedAt: machine.updatedAt || machine.capturedAt || h.nowIso(),
      connectorStatus: machine.online ? "online" : "offline"
    });

    return {
      id: telemetry.id,
      telemetry: {
        ...machine,
        online: telemetry.online,
        state: telemetry.state,
        progress: telemetry.progress,
        nozzleTemp: telemetry.nozzleTemp,
        nozzleTarget: telemetry.nozzleTarget,
        bedTemp: telemetry.bedTemp,
        bedTarget: telemetry.bedTarget,
        updatedAt: telemetry.updatedAt
      },
      online: telemetry.online,
      state: telemetry.state,
      progress: telemetry.progress,
      filename: telemetry.filename,
      nozzleTemp: telemetry.nozzleTemp,
      nozzleTarget: telemetry.nozzleTarget,
      bedTemp: telemetry.bedTemp,
      bedTarget: telemetry.bedTarget,
      message: telemetry.message,
      error: telemetry.error,
      firmware: telemetry.firmware,
      cameraRelay: telemetry.cameraRelay,
      cameraRelayUrl: telemetry.cameraRelayUrl,
      cameraStillUrl: telemetry.cameraStillUrl,
      cameraUpdatedAt: telemetry.cameraUpdatedAt,
      localCameraUrl: telemetry.localCameraUrl,
      connectorStatus: telemetry.online ? "online" : "offline",
      lastSeenAt: telemetry.updatedAt,
      lastConnectionStatus: telemetry.online ? "online" : "offline",
      lastConnectionAt: telemetry.updatedAt,
      lastConnectionMessage: telemetry.message || (telemetry.online ? "Connector synchronise" : "Connector hors ligne")
    };
  }

  function applyConnectorTelemetry(payload = {}){
    const list = Array.isArray(payload.machines) ? payload.machines : [];
    if(!list.length) return false;

    const known = mergeMachines(basePrinters(), st.machines.length ? st.machines : loadLocal());
    const map = new Map(known.map(m=>[m.id, m]));

    list.map(normalizeConnectorMachine).filter(m=>m.id).forEach(tel=>{
      const key = machineMatchKey(map, tel) || tel.id;
      const current = map.get(key) || h.defaultMachine({
        id:key,
        name:tel.name || key,
        type:tel.type || tel.connectionType || "other",
        connectionType:tel.connectionType || tel.type || "other",
        host:tel.host || tel.ip || tel.localIp || "",
        active:true,
        createdAt:h.nowIso()
      });
      map.set(key, h.defaultMachine({...current, ...tel, id:key}));
    });

    st.machines = [...map.values()];
    reconcileMachines(st.machines);
    st.loaded = true;
    scheduleRender();
    return true;
  }

  function printerList(){
    return reconcileMachines(st.machines.length ? st.machines : mergeMachines(basePrinters(), loadLocal()));
  }

  MTS.WorkshopMachines = {
    basePrinters,
    loadLocal,
    saveLocal,
    mergeMachines,
    reconcileMachines,
    collection,
    listenMachines,
    loadMachines,
    saveMachine,
    normalizeConnectorMachine,
    applyConnectorTelemetry,
    printerList,
    scheduleRender
  };
})(window.MTS);
